<template>
	<div class="exchange-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_exchange_page_v2.sec_10.title.one') }}
					<br />
					{{ $t('new_ui.personal_exchange_page_v2.sec_10.title.two') }}
				</h2>
				<p>
					{{ $t('new_ui.personal_exchange_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.personal_exchange_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_exchange_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_exchange_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img v-if="!isMobile" :src="img.imgExchangeSec10" alt="" />
					<img v-if="isMobile" :src="img.imgExchangeSec10M" alt="" />
				</div>
			</div>
		</section>

		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_exchange_page_v2.sec_04.title.one') }}<br />
					{{ $t('new_ui.personal_exchange_page_v2.sec_04.title.two') }}
				</h3>
				<p class="desc">
					{{ $t('new_ui.personal_exchange_page_v2.sec_04.desc.one') }}<br />
					{{ $t('new_ui.personal_exchange_page_v2.sec_04.desc.two') }}
				</p>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.one.title.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.one.title.two',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.one.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconExchange01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.two.title.one',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.two.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_exchange_page_v2.sec_04.cards.two.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconExchange02" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgExchangeSec10 from '@/assets/images/v2/img-exchange-sec-10.png';
import imgExchangeSec10M from '@/assets/images/v2/img-exchange-sec-10-m.png';
import iconExchange01 from '@/assets/images/v2/icon/icon-exchange-01.svg';
import iconExchange02 from '@/assets/images/v2/icon/icon-exchange-02.svg';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgExchangeSec10,
				imgExchangeSec10M,
				iconExchange01,
				iconExchange02,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
